import { render, staticRenderFns } from "./jxc.vue?vue&type=template&id=6051b0bb&scoped=true&"
import script from "./jxc.vue?vue&type=script&lang=js&"
export * from "./jxc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6051b0bb",
  null
  
)

export default component.exports